import styled from 'styled-components';

import { WithThemeProps, getMeasureProp } from '../../styles';
import { ViewLayoutProps } from './page-view';


export type ViewProps = {
	appearance?: 'paper' | 'transparent';
	layoutAppearance?: ViewLayoutProps['appearance'];
	fullWidth?: boolean;
	padding?: number | string;
	autoHeight?: boolean;
}

export type ExtraViewProps = {
	fullWidth?: boolean;
	padding?: number | string;
}

const ViewLayoutRoot = styled.section<WithThemeProps>`
	position: relative;
	width: 100%;
	height: auto;

	${(p: WithThemeProps) => `
		background-color: ${p.theme.color.bgLight};
	`}
`;

const ViewRoot = styled.div<ViewProps>`
	position: relative;
	display: flex;
	flex-flow: column nowrap;
	width: 100%;
	height: auto;
	min-height: calc(100vh - 70px);
	background-color: #fff;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
	z-index: 1;

	${p => p.fullWidth && `
		box-shadow: none;
	`}

	${p => p.padding && `
		padding: ${getMeasureProp(p.padding)};
	`}

	${p => p.appearance === 'transparent' && `
		background-color: transparent;
		box-shadow: none;
	`}

	${p => p.autoHeight && `
		min-height: 0;
	`}

	${p => p.layoutAppearance === 'nested-routes' && `
		min-height: calc(100vh - 126px);
	`}
`;

const ExtraViewRoot = styled.div<ExtraViewProps>`
	position: relative;
	width: inherit;

	${(p: WithThemeProps) => `
		background-color: ${p.theme.color.bgLight};
	`}

	${p => p.fullWidth && `
		width: 100%;
	`}

	${p => p.padding && `
		padding: ${getMeasureProp(p.padding)};
	`}
`;

const FixedView = styled.div`
	position: fixed;
	width: inherit;
	padding: 32px 50px 30px 30px;
`;

export {
	ViewLayoutRoot,
	ViewRoot,
	ExtraViewRoot,
	FixedView,
};
